import { Pencil, UserMinus } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { toast } from 'sonner'
import AttendanceButton from '~/components/AttendanceButton'
import { Button } from '~/components/ui/button'
import { tourAnchor } from '~/helpers/tour/anchors'
import SessionDetailView from '~/pages/backoffice/admin/sessions/detail/SessionDetailView'
import { demoSession } from '~/pages/help/demo/demo-session'
import DemoBanner from '~/pages/help/demo/DemoBanner'

/**
 * La fiche d'une session, en démonstration (#243) : la vraie vue, sur une
 * session fictive. Sa route n'a pas d'id, donc le centre d'aide sait lancer sa
 * visite ; rien ne s'y modifie ni ne s'y télécharge côté serveur.
 */
function SessionDemo() {
  const { t } = useTranslation()
  const { session, results } = demoSession(t)
  const inert = () => toast.info(t('helpDemo.inert'))

  return (
    <div className="flex w-full flex-col">
      <DemoBanner backTo="/back-office/help" />
      <SessionDetailView
        session={session}
        results={results}
        onDownloadReport={inert}
        downloadingReport={false}
        attendance={(
          <AttendanceButton onClick={inert} loading={false} {...tourAnchor('sessionDetail.attendance')}>
            {t('attendance.batch')}
          </AttendanceButton>
        )}
        // Des réponses fictives au questionnaire (#320), pour que la visite montre la carte.
        survey={{
          answered: 12,
          skipped: 3,
          satisfactionRate: 83.3,
          questions: [{ questionId: 'q1', label: t('helpDemo.session.survey.question'), average: 4.3, count: 12 }],
          modules: [{ moduleId: 'm1', title: t('helpDemo.session.survey.module'), average: 4.1, count: 11 }],
          comments: [{ label: t('helpDemo.session.survey.commentLabel'), text: t('helpDemo.session.survey.comment'), at: new Date() }],
        }}
        // Même colonne que la vraie fiche, pour que la visite la montre (#324).
        participantAction={() => (
          <Button variant="ghost" size="sm" onClick={inert}>
            <UserMinus className="mr-2 size-4" />
            {t('sessionDetail.dropout.declare')}
          </Button>
        )}
        headerActions={(
          <Button variant="outline" onClick={inert} {...tourAnchor('sessionDetail.edit')}>
            <Pencil className="mr-2 size-4" />
            {t('sessionDetail.edit')}
          </Button>
        )}
      />
    </div>
  )
}

export default SessionDemo
